<script lang="ts">
import { computed, defineComponent, h, unref } from 'vue';

import { classNames, hSlot } from '@components/utils';

import {
  makeInvertColor,
  makeThemeProps,
  makeTransparentProps,
  provideTheme,
  useInvertColor,
  useTransparent
} from '../../composable';

import type { PropType } from 'vue';

export const componentName = 'CdsToolbar';
export default defineComponent({
  name: componentName,
  props: {
    /**
     * Вложенный тулбар
     */
    inset: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    /**
     * Показать границу
     */
    bordered: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    /**
     * Убрать отступ справа или слева
     */
    noGutter: {
      type: String as PropType<'start' | 'end'>,
      default: undefined
    },
    /**
     * Убрать отступы
     */
    noGutters: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    ...makeTransparentProps(),
    ...makeInvertColor(),
    ...makeThemeProps()
  },
  setup(props, { slots }) {
    const { themeClasses } = provideTheme(props);
    const { invertColorClasses } = useInvertColor(props, componentName);
    const { transparentClasses } = useTransparent(props, componentName);

    const classes = computed(() =>
      classNames('cds-toolbar', {
        'cds-toolbar--inset': props.inset,
        'cds-toolbar--bordered': props.bordered,
        'cds-toolbar--no-gutters': props.noGutters,
        [`cds-toolbar--no-gutter-${props.noGutter}`]: props.noGutter
      })
    );

    return () =>
      h(
        'div',
        {
          class: classNames(unref(classes), unref(invertColorClasses), unref(transparentClasses), unref(themeClasses)),
          role: 'toolbar'
        },
        hSlot(slots.default)
      );
  }
});
</script>

<style lang="scss">
@import './CdsToolbar';
</style>
